import { Typography } from "antd";
import styles from "./textColor.module.css";

type RiskTextColorProps = {
  type?: "success" | "default" | "warning" | "danger";
  text: string;
};

export const RiskTextColor = ({ type, text }: RiskTextColorProps) => {
  if (!text) {
    return null;
  }

  return <Typography.Text className={styles[type ?? "default"]}>{text}</Typography.Text>;
};
